<div class="grid">
  <app-kpi-card
    class="kpi-card"
    [value]="data[0]?.value"
    [label]="'charts.labels.' + data[0]?.label | translate"
    icon="person-outline"
    [change]="data[0]?.delta_pct"
    [loading]="isLoading"
  ></app-kpi-card>
  <app-kpi-card
    class="kpi-card"
    [value]="data[1]?.value"
    [label]="'charts.labels.' + data[1]?.label | translate"
    icon="clock-outline"
    [change]="data[1]?.delta_pct"
    [loading]="isLoading"
    [formatFunction]="formatTimeFunction"
  ></app-kpi-card>
  <app-kpi-card
    class="kpi-card"
    [value]="data[2]?.value"
    [label]="'charts.labels.' + data[2]?.label | translate"
    icon="clock-outline"
    [change]="data[2]?.delta_pct"
    [loading]="isLoading"
    [formatFunction]="formatTimeFunction"
  ></app-kpi-card>
</div>
